import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import api from '../api';
import { 
  FETCH_PATIENT_DOCTORS, 
  FETCH_PATIENT_BY_ID,
  ON_PATIENT_SAVE_IMAGES,
  ON_PATIENT_DELETE_IMAGES,
  FETCH_PATIENT_HISTORY,
  ADD_NEW_PAID,
  ON_UPDATE_PATIENT,
  ON_DELETE_PAYMENT,
  DELETE_PATIENT_HISTORY,
  ON_SAVE_NEW_INTERVENTIONS
} from 'constants/ActionTypes';
import { fetchPatientByIdSuccess, updatePatientSuccess, showSinglePatientLoader, showSinglePatientMessage, saveImagesSuccess, deleteImagesSuccess, showPatientImageLoader, fetchPatientHistorySuccess, showSinglePatientHistoryLoader, addNewPaidSuccess, deletePaymentSuccess, deleteHistorySuccess, fetchDoctorsSuccess, showSavingInterventionsBtnLoader,
  saveInterventionsSuccess } from 'actions/SinglePatient';
import { userSignOut } from 'actions/Auth';

function* getPatient({ payload }) {
  try {
    const { patientId } = payload;
    yield put(showSinglePatientLoader());
    const authToken = localStorage.getItem('token');
    const patient = yield call(api.patientsApi.getPatientById, { authToken, patientId });

    if (patient.errorMessage) {
      yield put(showSinglePatientMessage(patient.errorMessage, true));
    } else {
      yield put(fetchPatientByIdSuccess(patient));
    }
  } catch (error) {
    console.log('error', error);
    yield put(showSinglePatientMessage(error.message || error, true));
    yield put(userSignOut());
  }
}

function* getDoctors() {
  try {
    const authToken = localStorage.getItem('token');
    const doctors = yield call(api.interventionsApi.getDoctors, { authToken });

    if (doctors.errorMessage) {
      yield put(showSinglePatientMessage(doctors.errorMessage, true));
    } else {
      yield put(fetchDoctorsSuccess(doctors));
    }
  } catch (error) {
    console.log('error', error);
    yield put(showSinglePatientMessage(error.message || error, true));
    yield put(userSignOut());
  }
}

function* onSaveImages({ payload }) {
  try {
    yield put(showPatientImageLoader());
    const authToken = localStorage.getItem('token');
    const images = yield call(api.patientsApi.uploadImages, { authToken, payload });

    if (images.errorMessage) {
      yield put(showSinglePatientMessage(images.errorMessage, true));
    } else {
      yield put(saveImagesSuccess(images));
    }
  } catch (error) {
    console.log('error', error);
    yield put(showSinglePatientMessage(error.message || error, true));
    yield put(userSignOut());
  }
}

function* onDeleteImages({ payload }) {
  try {
    yield put(showPatientImageLoader());

    const authToken = localStorage.getItem('token');
    const images = yield call(api.patientsApi.deleteImages, { authToken, payload });

    if (images.errorMessage) {
      yield put(showSinglePatientMessage(images.errorMessage, true));
    } else {
      yield put(deleteImagesSuccess(images));
    }
  } catch (error) {
    console.log('error', error);
    yield put(showSinglePatientMessage(error.message || error, true));
    yield put(userSignOut());
  }
}

function* getPatientsHistory({ payload }) {
  try {
    yield put(showSinglePatientHistoryLoader());
    const authToken = localStorage.getItem('token');
    const history = yield call(api.patientsApi.getPatientsHistory, { payload, authToken });

    if (history.errorMessage) {
      yield put(showSinglePatientMessage(history.errorMessage, true));
    } else {
      yield put(fetchPatientHistorySuccess(history));
    }
  } catch (error) {
    console.log('error', error);
    yield put(showSinglePatientMessage(error.message || error, true));
    yield put(userSignOut());
  }
}

function* addNewPaid({ payload }) {
  try {
    yield put(showSinglePatientHistoryLoader());
    const authToken = localStorage.getItem('token');
    const paid = yield call(api.patientsApi.addNewPaid, { payload, authToken });

    if (paid.errorMessage) {
      yield put(showSinglePatientMessage(paid.errorMessage, true));
    } else {
      yield put(addNewPaidSuccess(paid.patientId));
    }
  } catch (error) {
    console.log('error', error);
    yield put(showSinglePatientMessage(error.message || error, true));
    yield put(userSignOut());
  }
}

function* updatePatient({ payload }) {
  try {
    yield put(showSinglePatientLoader());
    const authToken = localStorage.getItem('token');

    const patients = yield call(api.patientsApi.updatePatient, { payload, authToken });

    if (patients.errorMessage) {
      yield put(showSinglePatientMessage(patients.errorMessage, true));
    } else {
      yield put(updatePatientSuccess(patients));
    }
  } catch (error) {
    yield put(showSinglePatientMessage(error.message || error, true));
    yield put(userSignOut());
  }
}

function* deletePayment({ payload }) {
  try {
    const { paymentId, patientId, historyId } = payload;

    yield put(showSinglePatientHistoryLoader());
    const authToken = localStorage.getItem('token');

    const payment = yield call(api.paymentsApi.deletePayment, { paymentId, historyId, authToken });

    if (payment.errorMessage) {
      yield put(showSinglePatientMessage(payment.errorMessage, true));
    } else {
      yield put(deletePaymentSuccess(patientId));
    }
  } catch (error) {
    console.log('error', error);
    yield put(showSinglePatientMessage(error.message || error, true));
    yield put(userSignOut());
  }
}

function* deleteHistory({ payload }) {
  try {
    const { historyId, patientId } = payload;

    yield put(showSinglePatientHistoryLoader());
    const authToken = localStorage.getItem('token');

    const patientHistory = yield call(api.paymentsApi.deleteHistory, { historyId, authToken });

    if (patientHistory.errorMessage) {
      yield put(showSinglePatientMessage(patientHistory.errorMessage, true));
    } else {
      yield put(deleteHistorySuccess(patientId));
    }
  } catch (error) {
    console.log('error', error);
    yield put(showSinglePatientMessage(error.message || error, true));
    yield put(userSignOut());
  }
}

function* saveInterventions({ payload }) {
  try {
    yield put(showSavingInterventionsBtnLoader());
    const authToken = localStorage.getItem('token');

    const interventions = yield call(api.interventionsApi.createInterventions, { payload, authToken });

    if (interventions.errorMessage) {
      yield put(showSinglePatientMessage(interventions.errorMessage, true));
    } else {
      yield put(saveInterventionsSuccess(interventions));
    }
  } catch (error) {
    console.log('error', error);
    yield put(showSinglePatientMessage(error.message || error, true));
    yield put(userSignOut());
  }
}

export function* fetchDoctors() {
  yield takeEvery(FETCH_PATIENT_DOCTORS, getDoctors);
}

export function* fetchPatient() {
  yield takeEvery(FETCH_PATIENT_BY_ID, getPatient);
}

export function* uploadImages() {
  yield takeEvery(ON_PATIENT_SAVE_IMAGES, onSaveImages);
}

export function* deleteImages() {
  yield takeEvery(ON_PATIENT_DELETE_IMAGES, onDeleteImages);
}

export function* fetchPatientsHistory() {
  yield takeEvery(FETCH_PATIENT_HISTORY, getPatientsHistory);
}

export function* addPaid() {
  yield takeEvery(ADD_NEW_PAID, addNewPaid);
}

export function* onUpdatePatient() {
  yield takeEvery(ON_UPDATE_PATIENT, updatePatient);
}

export function* onDeletePayment() {
  yield takeEvery(ON_DELETE_PAYMENT, deletePayment);
}

export function* onDeleteHistory() {
  yield takeEvery(DELETE_PATIENT_HISTORY, deleteHistory);
}

export function* onSaveNewInterventions() {
  yield takeEvery(ON_SAVE_NEW_INTERVENTIONS, saveInterventions);
}

export default function* rootSaga() {
  yield all([
    fork(fetchDoctors),
    fork(fetchPatient),
    fork(uploadImages),
    fork(deleteImages),
    fork(fetchPatientsHistory),
    fork(addPaid),
    fork(onUpdatePatient),
    fork(onDeletePayment),
    fork(onDeleteHistory),
    fork(onSaveNewInterventions),
  ]);
}



// WEBPACK FOOTER //
// ./sagas/SinglePatient.js